import React, {Fragment} from 'react';
import {PillButtons} from 'core/controls';

const ProfileSettings = ({
  controlLostFocus,
  controlChange,
  controlGetFocus,
  setElement,
  formData,
  auth,
}) => {
  const disableApplication = () => {
    if (!auth || !auth.user) {
      return '';
    }
    // console.log('isNewBusiness: ', auth.user.isNewBusiness);
    if (!auth.user?.permissions?.isNewBusiness?.isActive) {
      return "New Business";
    } else if (!auth.user?.permissions?.isInforce?.isActive) {
      return "Inforce";
    } else {
      return "";
    }
  };

  return (
    <div className="flexContainer twoCol">
      <PillButtons
        text="Default application at startup"
        getfocusCallback={controlGetFocus}
        getchangeCallback={controlChange}
        lostfocusCallback={controlLostFocus}
        stateData={formData}
        name="rdoDefaultApp"
        refItem={setElement}
        propStyle={{
          label: 'fontHdr3',
          control: 'radiocontrol buttonPill',
          pillcontainer: 'pillcontainer marginSm flexContainer noCols',
          inputcontainer: 'inputcontainer marginSm',
          child: 'childcontrol',
          pills: 'flexContainer',
        }}
        disableChoice={disableApplication()}
      />
      {/* </div> */}
    </div>
  );
};

export default ProfileSettings;
